import React, { createContext, useContext, useEffect, useState } from "react";

export enum Theme {
  LIGHT = "light",
  DARK = "dark",
  SYSTEM = "system",
}

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
  resolvedTheme: "light" | "dark";
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

interface ThemeProviderProps {
  children: React.ReactNode;
  defaultTheme?: Theme;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  defaultTheme = "dark",
}) => {
  const [theme, setThemeState] = useState<Theme>(() => {
    // const storedTheme = localStorage.getItem("theme") as Theme;
    // return storedTheme || defaultTheme;
    return defaultTheme as Theme;
  });

  // const [systemTheme, setSystemTheme] = useState<"light" | "dark">(() => {
  //   return window.matchMedia("(prefers-color-scheme: dark)").matches
  //     ? "dark"
  //     : "light";
  // });

  // const resolvedTheme = theme === "system" ? systemTheme : theme;

  const resolvedTheme = theme;

  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
    // localStorage.setItem("theme", newTheme);
  };

  const toggleTheme = () => {
    if (theme === Theme.LIGHT) {
      setTheme(Theme.DARK);
    } else if (theme === Theme.DARK) {
      setTheme(Theme.SYSTEM);
    } else {
      setTheme(Theme.LIGHT);
    }
  };

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(resolvedTheme);
  }, [resolvedTheme]);

  // Listen for system theme changes
  // useEffect(() => {
  //   const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  //   const handleChange = (e: MediaQueryListEvent) => {
  //     setSystemTheme(e.matches ? "dark" : "light");
  //   };

  //   mediaQuery.addEventListener("change", handleChange);
  //   return () => mediaQuery.removeEventListener("change", handleChange);
  // }, []);

  const value: ThemeContextType = {
    theme,
    setTheme,
    toggleTheme,
    resolvedTheme: resolvedTheme as "light" | "dark",
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
